import { IApplicationState } from '../../../../../../types/types';
import { getAsidePanel } from './getAsidePanel';

export const getAsidePanelWidth = (
    state: IApplicationState
): number => {
    return getAsidePanel(state).width || 0;
};
